import React from 'react';
import Svg from '../../Svg/Svg'
import ExhibitionMap from '../../ExhibitionMap/ExhibitionMap'
import styles from './AudioGuideMapModal.css'

const AudioGuideMapModal = ({ handleClose, show, artwork, mapClosing }) => {
  return show ? (
    <div className={`${styles.modal} ${mapClosing && styles.animateOut}`}>
      <div>
      <ExhibitionMap
        roomId={artwork.current_location_name}
        artwork={artwork}
      />
          <button 
            onClick={handleClose}
            className={styles.closeButton}
          >
            <Svg id='exit-fat' />
          </button>
      </div>
    </div>
  ) : null;
};

export default AudioGuideMapModal


// WEBPACK FOOTER //
// ./src/components/AudioGuideComponents/AudioGuideMap/AudioGuideMapModal.js